import {useNavigate} from "react-router-dom";
import {useCallback} from "react";
import {useTranslation} from "react-i18next";

import Button from "../сomponents/UI/Buttons/Button";

import './NotFound.sass';

const NotFoundPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const goHome = useCallback(() => {
        navigate('/');
    }, [navigate]);

    return (
        <main className="not-found d-flex justify-content-center align-items-center text-center">
            <div>
                <h1>404</h1>
                <p>{t("notFoundPage.subtext")}</p>
                <Button onClick={goHome}>{t("notFoundPage.actionButtonText")}</Button>
            </div>
        </main>
    );
};

export default NotFoundPage;